export default __webpack_public_path__ + "static/media/VasectomyConsent.c39e3b0b.pdf";